import React, { useRef } from 'react';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleChangeDate, handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { DesignationOptions, GenderOptions, YesNoOptions } from '../../../../constants/Options';
import { MdOutlinePhone } from 'react-icons/md';
import { CiCalendarDate } from 'react-icons/ci';
import FileTextBox from '../../../../constants/FileTextBox';
import { Designation } from '../../../../helpers/models/Models';

interface MargaToleAddFormViewProps {
  handleFormSuccess: () => void;
  data:{
    data: Designation[];
  }| null
}
const StaffCreateFormView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess, data }) => {
  const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});
  const designationOptions = DesignationOptions(data?.data);
  const initialValues = {
    mem_name: "",
    mem_name_nep: "",
    remarks: "",
    add_nep: "",
    add_eng: "",
    status: "",
    ward_no: "",
    sms_mob_no: "",
    dob: "",
    ctiz_no: "",
    gender: "",
    father_name: "",
    father_name_nep: "",
    photo: "",
    active: '1',
    mem_cate: '2',
    date_of_joining: "",
    date_of_leaving: "",
    shift: "",
    bank_holder_name: "",
    acc_number: "",
    bank_name: "",
    branch_name: "",
    bank_code: "",
    designation: "",
    initial_salary: "",
    grade_count: "",
    grade_amt: "",
    allowance: "",
    tax_amount: "",
    pr_status: "",
    pf_amount: "",
    pf_thap_amt: "",
    app_date: "",
    branch: "",
    ss_tax: "",
    insurance: "",
    ss_found: "",
    qualification: "",
    training: "",
    lang: "",
  };

  const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        const value = (values as Record<string, any>)[key];
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      });
      try {
        await postDataToTheServer(AppURL.PayrollURL + "payroll/staff/create/list/view/", formData).then((res) => {
          if (res?.status === 201) {
            ToastSuccess({ message: res?.message });
            action.resetForm();
          } else if (res?.status === 400) {
            ToastWarning(res?.message);
          } else {
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  });
  return (
    <Container padding={true}>
      <form onSubmit={handleSubmit}>
        <SecHeading type='add' label='Staff Add' />
        <Grid container columnSpacing={2} rowSpacing={0.8}>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              name='mem_name'
              label='Staff Full Name'
              handleChange={handleChange}
              value={values.mem_name}
              error={typeof errors.mem_name === 'string' ? errors.mem_name : undefined}
              handleBlur={handleBlur}
              touched={touched.mem_name}
              required={true}
              placeholder='Enter Staff Full Name'
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <NepaliInputBox
              label='Staff Full Name(Nepali)'
              name='mem_name_nep'
              value={values.mem_name_nep}
              handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'mem_name_nep' })}
              required={true}
              handleBlur={handleBlur}
              error={typeof errors.mem_name_nep === 'string' ? errors.mem_name_nep : undefined}
              placeholder='Enter Staff Full Name(nepali)'
              touched={touched.mem_name_nep}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              name='add_eng'
              label='Staff Address'
              handleChange={handleChange}
              value={values.add_eng}
              error={typeof errors.add_eng === 'string' ? errors.add_eng : undefined}
              handleBlur={handleBlur}
              touched={touched.add_eng}
              required={true}
              placeholder='Enter Address'
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <NepaliInputBox
              label='Address(Nepali)'
              name='add_nep'
              value={values.add_nep}
              handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'add_nep' })}
              required={true}
              handleBlur={handleBlur}
              error={typeof errors.add_nep === 'string' ? errors.add_nep : undefined}
              placeholder='Enter Address(nepali)'
              touched={touched.add_nep}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              name='ward_no'
              label='Ward No.'
              handleChange={handleChange}
              value={values.ward_no}
              error={typeof errors.ward_no === 'string' ? errors.ward_no : undefined}
              handleBlur={handleBlur}
              touched={touched.ward_no}
              required={false}
              placeholder='Enter Ward No.'
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              prefix={<MdOutlinePhone />}
              label='SMS Mobile No.'
              name='sms_mob_no'
              handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'sms_mob_no' })}
              handleBlur={handleBlur}
              value={values.sms_mob_no}
              error={errors.sms_mob_no}
              touched={touched.sms_mob_no}
              placeholder='XXX-XXXXXXX'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              prefix={<CiCalendarDate />}
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'dob' })}
              label='DOB(BS)'
              name='dob'
              handleBlur={handleBlur}
              value={values.dob}
              error={errors.dob}
              touched={touched.dob}
              placeholder='XXXX/XX/XX'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              label='Citizenship No.'
              name='ctiz_no'
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.ctiz_no}
              error={errors.ctiz_no}
              touched={touched.ctiz_no}
              placeholder='000-000-0'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <SelectInputBox
              label='Gender'
              options={GenderOptions}
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }
              }
              required={false}
              placeholder='Select Gender'
              name='gender'
              handleBlur={() => {
                handleBlur({ target: { name: 'gender' } });
              }}
              value={values.gender}
              touched={touched.gender}
              errors={errors.gender}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <SelectInputBox
              label='Designation'
              options={designationOptions}
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              required={false}
              placeholder='Select designation'
              name='designation'
              handleBlur={() => {
                handleBlur({ target: { name: 'designation' } });
              }}
              value={values.designation}
              touched={touched.designation}
              errors={errors.designation}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox type='text'
              label='Father Name'
              name='father_name'
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.father_name}
              error={errors.father_name}
              touched={touched.father_name}
              placeholder='Enter father name'
              required={false} />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <NepaliInputBox
              label='Father Name(Nepali)'
              name='father_name_nep'
              handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'father_name_nep' })}
              value={values.father_name_nep}
              error={errors.father_name_nep}
              handleBlur={handleBlur}
              placeholder='Enter father name(nepali)'
              touched={touched.father_name_nep}
              required={false} />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              prefix={<CiCalendarDate />}
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_of_joining' })}
              label='Date of Joinging'
              name='date_of_joining'
              handleBlur={handleBlur}
              value={values.date_of_joining}
              error={errors.date_of_joining}
              touched={touched.date_of_joining}
              placeholder='XXXX/XX/XX'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              prefix={<CiCalendarDate />}
              handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_of_leaving' })}
              label='Date of Leaving'
              name='date_of_leaving'
              handleBlur={handleBlur}
              value={values.date_of_leaving}
              error={errors.date_of_leaving}
              touched={touched.date_of_leaving}
              placeholder='XXXX/XX/XX'
              required={false}
            />
          </Grid>

          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Qualification'
              name='qualification'
              handleBlur={handleBlur}
              value={values.qualification}
              error={errors.qualification}
              touched={touched.qualification}
              placeholder='Enter Qualification'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>

            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Training'
              name='training'
              handleBlur={handleBlur}
              value={values.training}
              error={errors.training}
              touched={touched.training}
              placeholder='Enter training'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>

            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Language'
              name='lang'
              handleBlur={handleBlur}
              value={values.lang}
              error={errors.lang}
              touched={touched.lang}
              placeholder='Enter Language'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Bank Holder Name'
              name='bank_holder_name'
              handleBlur={handleBlur}
              value={values.bank_holder_name}
              error={errors.bank_holder_name}
              touched={touched.bank_holder_name}
              placeholder='Enter Bank Holder Name'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Account Number'
              name='acc_number'
              handleBlur={handleBlur}
              value={values.acc_number}
              error={errors.acc_number}
              touched={touched.acc_number}
              placeholder='Enter Account Number'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Bank Name'
              name='bank_name'
              handleBlur={handleBlur}
              value={values.bank_name}
              error={errors.bank_name}
              touched={touched.bank_name}
              placeholder='Enter Bank Name'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Branch Name'
              name='branch_name'
              handleBlur={handleBlur}
              value={values.branch_name}
              error={errors.branch_name}
              touched={touched.branch_name}
              placeholder='Enter Branch Name'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              handleChange={handleChange}
              label='Bank Code'
              name='bank_code'
              handleBlur={handleBlur}
              value={values.bank_code}
              error={errors.bank_code}
              touched={touched.bank_code}
              placeholder='Enter Bank Code'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Initial Salary'
              name='initial_salary'
              handleBlur={handleBlur}
              value={values.initial_salary}
              error={errors.initial_salary}
              touched={touched.initial_salary}
              placeholder='000'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Grade Count'
              name='grade_count'
              handleBlur={handleBlur}
              value={values.grade_count}
              error={errors.grade_count}
              touched={touched.grade_count}
              placeholder='0'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Grade Amount'
              name='grade_amt'
              handleBlur={handleBlur}
              value={values.grade_amt}
              error={errors.grade_amt}
              touched={touched.grade_amt}
              placeholder='0'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Allowance'
              name='allowance'
              handleBlur={handleBlur}
              value={values.allowance}
              error={errors.allowance}
              touched={touched.allowance}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Tax Amount'
              name='tax_amount'
              handleBlur={handleBlur}
              value={values.tax_amount}
              error={errors.tax_amount}
              touched={touched.tax_amount}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='PF Amount'
              name='pf_amount'
              handleBlur={handleBlur}
              value={values.pf_amount}
              error={errors.pf_amount}
              touched={touched.pf_amount}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='PF Thap Amount'
              name='pf_thap_amt'
              handleBlur={handleBlur}
              value={values.pf_thap_amt}
              error={errors.pf_thap_amt}
              touched={touched.pf_thap_amt}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Sa. Su. Tax'
              name='ss_tax'
              handleBlur={handleBlur}
              value={values.ss_tax}
              error={errors.ss_tax}
              touched={touched.ss_tax}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Insurance'
              name='insurance'
              handleBlur={handleBlur}
              value={values.insurance}
              error={errors.insurance}
              touched={touched.insurance}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='number'
              handleChange={handleChange}
              label='Insurance'
              name='ss_found'
              handleBlur={handleBlur}
              value={values.ss_found}
              error={errors.ss_found}
              touched={touched.ss_found}
              placeholder='0.00'
              required={false}
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <FileTextBox
              type='file'
              label='Photo'
              name='photo'
              handleBlur={handleBlur}
              ref={(el) => (fileInputRefs.current['photo'] = el)}
              handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0];
                if (file) {
                  setFieldValue("photo", file); // Handle the file change correctly
                }
              }}
              error={errors.photo}
              touched={touched.photo}
              required={false} />
          </Grid>

          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <InputTextBox
              type='text'
              name='remarks'
              label='Remarks'
              handleChange={handleChange}
              value={values.remarks}
              error={typeof errors.remarks === 'string' ? errors.remarks : undefined}
              handleBlur={handleBlur}
              touched={touched.remarks}
              required={false}
              placeholder='Enter Remarks'
            />
          </Grid>
          <Grid item xl={2} lg={2} sm={6} md={3} xs={12}>
            <SelectInputBox
              label="Active"
              options={YesNoOptions}
              name='status'
              required={true}
              placeholder='Select status'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }
              }
              value={values.status}
              touched={touched.status}
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <EndBaseLine top={18}>
              <Button btn_type='save' type='submit' el='button' />
            </EndBaseLine>
          </Grid>
        </Grid>
      </form>

    </Container>
  )
}

export default StaffCreateFormView